
import LottieWeb from "../services/LottieWeb.js"
import CalendlyService from "../services/CalendlyService.js"
import QuoteInput from "./QuoteInput"
import AppButton from "./AppButton"
import Article from "./Article.vue"
import OrderedListItem from "./OrderedListItem"
import stubDirectives from "../mixins/stubDirectives"
import formatStoryblokAssetUrl from "../helpers/formatStoryblokAssetUrl"

export default {
  components: {
    QuoteInput,
    AppButton,
    Article,
    OrderedListItem
  },
  mixins: [stubDirectives],
  props: {
    heading: {
      required: true,
      type: String
    },
    richHeadingText: {
      type: Object,
      default: null
    },
    subheading: {
      type: String,
      default: null
    },
    fontColor: {
      type: String,
      default: null
    },
    leftBackgroundColor: {
      type: String,
      default: null
    },
    leftBackgroundImage: {
      type: Object,
      default: null
    },
    leftImageCoveringColumn: {
      type: Boolean,
      default: false
    },
    bannerBackgroundImage: {
      type: Object,
      default: null
    },
    rightBackgroundColor: {
      type: String,
      default: null
    },
    rightImageAsset: {
      type: Object,
      default: null
    },
    rightStaticImage: {
      type: Object,
      default: null
    },
    rightImageContained: {
      type: Boolean,
      default: false
    },
    button: {
      type: Array,
      default: () => []
    },
    quoteInput: {
      type: Array,
      default: () => [{}]
    },
    loginOption: {
      type: Object,
      default: null
    },
    overlapText: {
      type: Boolean,
      default: false
    },
    rightImageLarge: {
      type: Boolean,
      default: false
    },
    lowercaseHeading: {
      type: Boolean,
      default: false
    },
    smallHeading: {
      type: Boolean,
      default: false
    },
    quoteButtonVariant: {
      type: String,
      default: null
    },
    rightImageStackTopOnMobile: {
      type: Boolean,
      default: false
    },
    rightImageFullSize: {
      type: Boolean,
      default: false
    },
    headingListItems: {
      type: Array,
      default: () => []
    },
    sectionId: {
      type: String,
      default: ""
    },
    showBookACall: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonProps() {
      const buttonBlock = this.button && this.button[0]
      if (buttonBlock) {
        const { _uid, component, ...props } = buttonBlock
        return props
      }
      return null
    },
    leftSectionStyle() {
      return {
        color: this.fontColor,
        backgroundColor: this.leftBackgroundColor,
        backgroundImage: `url(${this.leftBackgroundImage &&
          this.leftBackgroundImage.filename})`
      }
    },
    rightSectionStyle() {
      return {
        backgroundColor: this.rightBackgroundColor
      }
    },
    bannerBackgroundImageStyle() {
      return {
        backgroundImage: `url(${this.bannerBackgroundImage &&
          this.bannerBackgroundImage.filename})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
      }
    }
  },
  async mounted() {
    if (screen.width >= 769) {
      const animationUrl = formatStoryblokAssetUrl(
        this.rightImageAsset && this.rightImageAsset.filename
      )

      const lottie = await LottieWeb.getLottieLight()
      this.anim = lottie.loadAnimation({
        container: this.$refs.soeAnimation,
        render: "svg",
        loop: 1,
        autoplay: true,
        path: animationUrl
      })
    }
  },
  methods: {
    handleValidPostcode(data) {
      const validPostcode = data.customerPostcode
      this.$emit("valid-postcode", validPostcode)
    },
    handleBookACall() {
      CalendlyService.openPopup()
    }
  }
}
